let HcDOMContentLoaded = false;
window.addEventListener('DOMContentLoaded', () => HcDOMContentLoaded = true);

function HcUpdateCrossedOut(opts) {
  const {
    variants,
    options,
    optionNames,
    selectors,
    onDisable,
    hierarchy: isHierarchical
  } = opts;

  const {
    radioAllElements: radioAllSelector,
    radioElement: radioSelector,
    radioContainer: swatchSelector,
    selectorElement,
    anySelectorElement,
  } = selectors;

  const getIndex = name => options.findIndex(op => op.toLowerCase() == name.toLowerCase());

  function getAbsoluteAvailableOptions(optionVals) {
    const req_index = optionVals.findIndex(opt => opt == "$x");
    if (req_index < 0) throw new TypeError("$x must be passed to the options array");

    return variants
      .filter(variant => {
        if (!variant.available) return false;
        return variant.options.every((opt, i) => (
          i === req_index || optionVals[i] === '$all' || optionVals[i] === opt
        ));
      })
      .map(variant => variant.options[req_index]);
  }

  function getAbsolutePossibleOptions(optionVals) {
    const req_index = optionVals.findIndex(opt => opt == "$x");
    if (req_index < 0) throw new TypeError("$x must be passed to the options array");

    return variants
      .filter(variant => {
        return variant.options.every((opt, i) => (
          i === req_index || optionVals[i] === '$all' || optionVals[i] === opt
        ));
      })
      .map(variant => variant.options[req_index]);
  }

  function getAvailableOptions(opts, requestedOptionName) {
    const temp = [...opts];
    if (isHierarchical) {
      const req_index = temp.findIndex(opt => opt == "$x");
      const reversed = [...optionNames].reverse();
      for (const name of reversed) {
        if (name === requestedOptionName) break;
        const i = getIndex(name);
        temp[i] = "$all";
      }
    }
    return getAbsoluteAvailableOptions(temp);
  }

  function getPossibleOptions(opts, requestedOptionName) {
    const temp = [...opts];
    if (isHierarchical) {
      const req_index = temp.findIndex(opt => opt == "$x");
      const reversed = [...optionNames].reverse();
      for (const name of reversed) {
        if (name === requestedOptionName) break;
        const i = getIndex(name);
        temp[i] = "$all";
      }
    }
    return getAbsolutePossibleOptions(temp);
  }

  function getSelectedOptions() {
    return options.map((name, i) => {
      const selector = selectorElement ? selectorElement(i) : `${radioSelector(i)}:checked`;
      const selected = document.querySelector(selector);
      return selected ? selected.value : null;
    });
  }

  function fireUpdateEvent(optionIndex, optionSelector, availableOptions) {
    const e = new CustomEvent('hc-soldout:update', {
      detail: {
        optionIndex,
        optionSelector,
        availableOptions,
        optionName: options[optionIndex].toLowerCase()
      }
    });
    document.dispatchEvent(e);
  }

  const disablerFn = (el, shouldCrossOut, shouldHide) => {
    const label = document.querySelector(`label[for="${el.id}"]`);
    if (shouldHide) {
      el.style.display = 'none';
      if (label) label.style.display = 'none';
    } else {
      el.style.display = '';
      if (label) label.style.display = '';
    }

    if (label) {
      label.classList.toggle('hc-soldout-option', shouldCrossOut);
      label.classList.remove('disabled');
      label.style.pointerEvents = 'auto';
    }

    el.disabled = false;
  };

  function updateOptions(selectedOptions, changedOption = null) {
    const selectorMap = optionNames.map(name => {
      const i = getIndex(name);
      return [i, selectorElement ? selectorElement(i) : radioSelector(i), name];
    });

    const changedIndex = changedOption ? selectorMap.find(([i, s]) => {
      const el = changedOption.closest(s);
      return el !== null;
    })?.[0] : -1;

    const selectedAfter = [...selectedOptions];

    for (const [i, selector, name] of selectorMap) {
      const available = getAvailableOptions(
        selectedAfter.map((val, j) => j === i ? "$x" : val),
        name
      );
      const possible = getPossibleOptions(
        selectedAfter.map((val, j) => j === i ? "$x" : val),
        name
      );

      let inputs;
      if (selectorElement) {
        const container = document.querySelector(selector);
        if (!container) continue;
        inputs = container.querySelectorAll('[value]');
      } else {
        inputs = document.querySelectorAll(selector);
      }

      let hasValidChecked = false;
      let firstAvailableInput = null;
      let firstPossibleInput = null;

      inputs.forEach(input => {
        const val = input.getAttribute('value');
        const exists = possible.includes(val);
        const isAvailable = available.includes(val);

        const shouldHide = !exists;
        const shouldCrossOut = exists && !isAvailable;

        disablerFn(input, shouldCrossOut, shouldHide);

        if (!shouldHide && isAvailable && !firstAvailableInput) {
          firstAvailableInput = input;
        }

        if (!shouldHide && exists && !firstPossibleInput) {
          firstPossibleInput = input;
        }

        if (input.checked && exists) {
          hasValidChecked = true;
          selectedAfter[i] = val;
        }
      });

      const shouldAutoSelect = (changedIndex !== -1 && i > changedIndex);

      if ((!hasValidChecked || shouldAutoSelect)) {
        if (firstAvailableInput) {
          firstAvailableInput.dispatchEvent(new MouseEvent('click', { bubbles: true }));
          selectedAfter[i] = firstAvailableInput.value;
        } else if (firstPossibleInput) {
          firstPossibleInput.dispatchEvent(new MouseEvent('click', { bubbles: true }));
          selectedAfter[i] = firstPossibleInput.value;
        }
      }

      fireUpdateEvent(i, selector, available);
    }
  }

  function onLoad() {
    updateOptions(getSelectedOptions());

    document.body.addEventListener('change', e => {
      if (e.hcIgnore) return;

      const trigger =
        e.target.closest(radioAllSelector) || e.target.closest(anySelectorElement);

      if (trigger) {
        const selected = getSelectedOptions();
        updateOptions(selected, trigger);
      }
    });
  }

  if (HcDOMContentLoaded || document.readyState === "complete") {
    onLoad();
  } else {
    window.addEventListener('DOMContentLoaded', onLoad);
  }
}